<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item :to="{ name: 'DashboardHome' }">
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: 'PartnerMarketingEventList' }">點數/商品兌換活動</b-breadcrumb-item>
            <b-breadcrumb-item v-if="fromEventPage && parentEvent" @click="backToEventList">{{ parentEvent.name }}</b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: fromEventPage ? 'PartnerMarketingPlanListByEvent' : 'PartnerMarketingPlanList', params: fromEventPage ? { partnerMarketingEventId: $route.params.partnerMarketingEventId } : {} }">
              兌換活動方案
            </b-breadcrumb-item>
            <b-breadcrumb-item
              v-if="partnerMarketingPlan"
              :to="{
                name: fromEventPage ? 'PartnerMarketingPlanViewByEvent' : 'PartnerMarketingPlanView',
                params: fromEventPage ? {
                  partnerMarketingEventId: $route.params.partnerMarketingEventId,
                  partnerMarketingPlanId: planId
                } : {
                  partnerMarketingPlanId: planId
                }
              }"
            >
              {{ partnerMarketingPlan.name }}
            </b-breadcrumb-item>
            <b-breadcrumb-item active>序號管理</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-overlay :show="showLoading">
          <b-card>
            <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
              <h4 class="col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold">
                序號管理
              </h4>
              <b-input-group class="col-12 col-xl-6 mb-2">
                <template v-if="!isDeleteMode">
                  <b-button
                    variant="primary"
                    class="mr-2"
                    @click="handleExport"
                  ><i class="mdi mdi-download"></i>匯出</b-button>
                  <b-button
                    variant="danger"
                    class="mr-2"
                    @click="enterDeleteMode"
                    v-if="checkPermission([consts.PARTNER_MARKETING_CODE_DELETE])"
                  ><i class="mdi mdi-delete"></i>批次刪除</b-button>
                  <b-button
                    variant="success"
                    class="mr-2"
                    @click="showUploadModal"
                    v-if="checkPermission([consts.PARTNER_MARKETING_CODE_CREATE])"
                  ><i class="mdi mdi-upload"></i>批次上傳</b-button>
                </template>
                <template v-else>
                  <b-button
                    variant="secondary"
                    class="mr-2"
                    @click="cancelDeleteMode"
                  >取消</b-button>
                  <b-button
                    variant="danger"
                    class="mr-2"
                    @click="confirmBatchDelete"
                    :disabled="selectedItems.length === 0"
                  ><i class="mdi mdi-delete"></i>刪除序號</b-button>
                </template>
                <b-form-input
                  v-model="query.keyword"
                  placeholder="搜尋序號"
                  v-on:keyup.enter="handlePageReset"
                  v-if="!isDeleteMode"
                ></b-form-input>
                <b-input-group-append v-if="!isDeleteMode">
                  <b-button @click="handlePageReset"><i class="fa fa-search"></i></b-button>
                </b-input-group-append>
              </b-input-group>
              <div class="col-12 col-xl-8">
                <span>方案名稱：{{ partnerMarketingPlan ? partnerMarketingPlan.name : '' }}</span><br/>
                <span>序號總數：{{ serialStats.total || 0 }}</span><br/>
                <span>未指派數目：{{ serialStats.not_belong_count || 0 }}</span><br/>
                <span>已指派數目：{{ serialStats.belong_count || 0 }}</span><br/>
              </div>
            </div>

            <b-card-text>
              <div class="row">
                <div class="col-12">
                  <b-overlay rounded="sm">
                    <b-table
                      striped
                      hover
                      responsive
                      :items="serials"
                      :fields="displayFields"
                      :busy="isLoading"
                      show-empty
                      @row-clicked="rowClicked"
                    >
                      <template #table-busy>
                        <div class="text-center my-2">
                          <b-spinner class="align-middle"></b-spinner>
                        </div>
                      </template>
                      <template #cell(selected)="data">
                        <b-form-checkbox
                          v-if="!data.item.redeem_at"
                          v-model="data.item.selected"
                          @change="updateSelectedItems"
                        ></b-form-checkbox>
                      </template>
                      <template #head(selected)>
                        <b-form-checkbox
                          v-model="selectAll"
                          @change="toggleSelectAll"
                        ></b-form-checkbox>
                      </template>
                      <template #cell(belong_at)="data">
                        {{ formatDate(data.item.belong_at) }}
                      </template>
                      <template #cell(is_enabled)="data">
                        <b-badge :variant="data.item.is_enabled ? 'success' : 'danger'">
                          {{ data.item.is_enabled ? '啟用' : '停用' }}
                        </b-badge>
                      </template>
                      <template #cell(status)="data">
                        <b-badge :variant="getStatusVariant(data.item)">
                          {{ getStatusText(data.item) }}
                        </b-badge>
                      </template>
                      <template #cell(actions)="data">
                        <div class="text-center">
                          <b-button
                            :variant="data.item.is_enabled ? 'warning' : 'success'"
                            size="sm"
                            class="mr-1"
                            @click="toggleCodeStatus(data.item)"
                            v-if="checkPermission([consts.PARTNER_MARKETING_CODE_MODIFY])"
                          >
                            {{ data.item.is_enabled ? '停用' : '啟用' }}
                          </b-button>
                          <b-button
                            variant="danger"
                            size="sm"
                            :disabled="!canDelete(data.item)"
                            @click="deleteCode(data.item)"
                            v-if="checkPermission([consts.PARTNER_MARKETING_CODE_DELETE])"
                          >
                            刪除
                          </b-button>
                        </div>
                      </template>
                    </b-table>
                  </b-overlay>
                </div>
              </div>
              <CustomPagination
                :currentPage="pagination.page"
                :totalRows="pagination.total"
                :perPage="pagination.per_page"
                @page-change="handlePageChange"
                @per-page-change="handlePerPageChange"
              />
            </b-card-text>
          </b-card>
        </b-overlay>
      </div>
    </div>

    <b-modal id="modal-upload" title="批次上傳" @ok="uploadSerials">
      <b-overlay :show="showLoadingUpload">
        <div class="form-group">
          <label>請上傳序號 Excel 檔案</label>
          <ul class="text-danger">
            <li>第一欄位為序號，不得留空</li>
            <li>第二欄位為廠編，不得留空</li>
            <li>每行一個序號</li>
            <li>序號長度不能超過 30 個字元</li>
          </ul>
          <b-form-file plain v-model="uploadFile" placeholder="尚未選擇檔案" browse-text="瀏覽"></b-form-file>
          <b-button
            class="mt-2"
            size="sm"
            variant="outline-primary"
            href="/excel/marketing_codes.xlsx"
          ><i class="fa fa-file-text"></i>下載範例檔案</b-button>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import partnerMarketingPlan from '@/apis/partnerMarketingPlan'
import partnerMarketingEvent from '@/apis/partnerMarketingEvent'
import partnerMarketingPlanSerial from '@/apis/partnerMarketingPlanSerial'
import { BBadge, BButton, BCard, BTable, BFormInput, BInputGroup, BInputGroupAppend, BBreadcrumb, BBreadcrumbItem, BFormFile, BOverlay, BModal, BFormCheckbox, BSpinner } from 'bootstrap-vue'
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue"
import PermissionChecker from "@/utils/PermissionChecker"
import * as consts from "@/consts"
import moment from 'moment'

export default {
  components: { BBadge, BButton, BCard, BTable, BFormInput, BInputGroup, BInputGroupAppend, BBreadcrumb, BBreadcrumbItem, BFormFile, BOverlay, BModal, BFormCheckbox, BSpinner, CustomPagination },
  data() {
    return {
      consts,
      serials: [],
      isLoading: false,
      showLoading: false,
      showLoadingUpload: false,
      query: { keyword: '', page: 1, per_page: 10 },
      pagination: {
        page: 1,
        per_page: 10,
        total: 0
      },
      fields: [
        { key: 'code', label: '序號', sortable: true },
        { key: 'partner_code', label: '廠編', sortable: true },
        { key: 'customer.outer_code', label: '會員編號' },
        { key: 'customer.name', label: '會員名稱' },
        { key: 'belong_at', label: '指派時間', sortable: true },
        { key: 'is_enabled', label: '啟用/停用' },
        { key: 'status', label: '使用狀況' },
        { key: 'actions', label: '操作' }
      ],
      partnerMarketingPlan: null,
      parentEvent: null,
      serialStats: {},
      uploadFile: null,
      isDeleteMode: false,
      selectedItems: [],
      selectAll: false
    }
  },
  computed: {
    fromEventPage() {
      return !!this.$route.params.partnerMarketingEventId;
    },
    planId() {
      return this.$route.params.planId;
    },
    displayFields() {
      let fields = [...this.fields];
      
      // 如果沒有 修改 或 刪除 權限，隱藏操作欄位
      const hasActionPermission = this.checkPermission([this.consts.PARTNER_MARKETING_CODE_MODIFY]) || 
                                  this.checkPermission([this.consts.PARTNER_MARKETING_CODE_DELETE]);

      if (!hasActionPermission) {
        fields = fields.filter(f => f.key !== 'actions');
      }

      if (this.isDeleteMode) {
        return [{ key: 'selected', label: '' }, ...fields];
      }
      return fields;
    },
    unusedCodesCount() {
      // 計算未使用的序號數量
      return this.selectedItems.filter(item => !item.redeem_at).length;
    }
  },
  async created() {
    await this.fetchPartnerMarketingPlan();
    if (this.fromEventPage) {
      await this.fetchParentEvent();
    }
    await this.fetchSerialStats();
    this.fetchList(1);
  },
  methods: {
    formatDate(val) {
      return val ? moment(val).format('YYYY-MM-DD HH:mm') : '-'
    },
    async fetchList(page = 1) {
      this.isLoading = true;
      this.pagination.page = page;
      
      try {
        const response = await partnerMarketingPlanSerial.getCodes(this.planId, {
          page,
          per_page: this.pagination.per_page,
          keyword: this.query.keyword
        });
        
        this.serials = response.data.data || [];
        this.pagination.total = response.data.meta ? response.data.meta.total : 0;
      } catch (error) {
        this.$bvToast.toast('載入序號列表失敗', { variant: 'danger', solid: true });
      } finally {
        this.isLoading = false;
      }
    },
    async fetchSerialStats() {
      try {
        const response = await partnerMarketingPlanSerial.getCodeStats(this.planId);
        this.serialStats = response.data.data || {};
      } catch (error) {
        console.error('Failed to fetch serial stats:', error);
      }
    },
    async fetchPartnerMarketingPlan() {
      try {
        const response = await partnerMarketingPlan.getPartnerMarketingPlan(this.planId);
        this.partnerMarketingPlan = response.data.data;
      } catch (error) {
        console.error('Failed to fetch partner marketing plan:', error);
      }
    },
    async fetchParentEvent() {
      try {
        const response = await partnerMarketingEvent.getPartnerMarketingEvent(this.$route.params.partnerMarketingEventId);
        this.parentEvent = response.data.data;
      } catch (error) {
        console.error('Failed to fetch parent event:', error);
      }
    },
    handlePageReset() {
      this.fetchList(1);
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
    handlePageChange(page) {
      this.fetchList(page);
    },
    handlePerPageChange(perPage) {
      this.pagination.per_page = perPage;
      this.fetchList(1);
    },
    async handleExport() {
      try {
        this.isLoading = true;
        await partnerMarketingPlanSerial.exportCodes(this.planId, {
          keyword: this.query.keyword
        }).then(() => {
          this.$swal({
            title: '成功',
            text: "可至“我的主控台”查看紀錄及下載檔案",
            showCancelButton: true,
            cancelButtonText: '確認',
            type: 'success',
            confirmButtonText: '前往查看',
          }).then((result) => {
            if (result.value) {
              this.$router.push({
                name: "MyConsoleDownloadFileList",
                params: { org_code: this.$route.params.org_code },
              });
            }
          });
        });
      } catch (error) {
        this.$bvToast.toast('匯出失敗', { variant: 'danger', solid: true });
      } finally {
        this.isLoading = false;
      }
    },
    showUploadModal() {
      this.$bvModal.show('modal-upload');
    },
    async uploadSerials() {
      if (!this.uploadFile) {
        this.$bvToast.toast('請選擇檔案', { variant: 'warning', solid: true });
        return;
      }
      
      this.showLoadingUpload = true;
      const formData = new FormData();
      formData.append('file', this.uploadFile);
      
      try {
        const response = await partnerMarketingPlanSerial.uploadCodes(this.planId, formData);
        const stats = response.data.data;

        let message = `成功：${stats.success_count} 筆`;
        if (stats.update_count > 0) {
          message += `<br>更新：${stats.update_count} 筆`;
        }
        if (stats.duplicate_count > 0) {
          message += `<br>重複：${stats.duplicate_count} 筆`;
        }
        if (stats.length_error_count > 0) {
          message += `<br>長度超限：${stats.length_error_count} 筆`;
        }
        if (stats.fail_count > 0) {
          message += `<br>其他錯誤：${stats.fail_count} 筆`;
          message += `<br><span class="text-danger">※ 上傳欄位：序號、廠編，皆不得留空！</span>`;
        }

        this.$swal.fire({
          type: 'success',
          title: '上傳完成！',
          html: message
        });
        this.$bvModal.hide('modal-upload');
        this.uploadFile = null;
        await this.fetchSerialStats();
        this.fetchList(1);
      } catch (error) {
        this.$bvToast.toast('上傳失敗', { variant: 'danger', solid: true });
      } finally {
        this.showLoadingUpload = false;
      }
    },
    getStatusVariant(item) {
      if (item.redeem_at) return 'secondary';
      if (item.apply_at) return 'info';
      if (item.belong_at) return 'warning';
      return 'success';
    },
    getStatusText(item) {
      if (item.redeem_at) return '已使用';
      if (item.apply_at) return '已領取';
      if (item.belong_at) return '已指派';
      return '未指派';
    },
    backToEventList() {
      this.$router.push({ name: 'PartnerMarketingEventList' });
    },
    enterDeleteMode() {
      this.isDeleteMode = true;
      this.selectedItems = [];
      this.selectAll = false;
      // 為每個項目添加 selected 屬性
      this.serials = this.serials.map(item => ({
        ...item,
        selected: false
      }));
    },
    cancelDeleteMode() {
      this.isDeleteMode = false;
      this.selectedItems = [];
      this.selectAll = false;
      // 清除 selected 屬性
      this.serials = this.serials.map(item => {
        const { selected, ...rest } = item; // eslint-disable-line no-unused-vars
        return rest;
      });
    },
    rowClicked(item) {
      if (this.isDeleteMode && !item.redeem_at) {
        item.selected = !item.selected;
        this.updateSelectedItems();
      }
    },
    toggleSelectAll() {
      this.serials = this.serials.map(item => ({
        ...item,
        selected: !item.redeem_at ? this.selectAll : false
      }));
      this.updateSelectedItems();
    },
    updateSelectedItems() {
      this.selectedItems = this.serials.filter(item => item.selected);
      const selectableItems = this.serials.filter(item => !item.redeem_at);
      this.selectAll = this.selectedItems.length === selectableItems.length && selectableItems.length > 0;
    },
    async confirmBatchDelete() {
      // 計算未使用的序號數量
      const unusedCount = this.selectedItems.filter(item => !item.redeem_at).length;
      
      if (unusedCount === 0) {
        this.$swal.fire({
          type: 'warning',
          title: '無法刪除',
          text: '所選序號都已被使用，無法刪除'
        });
        return;
      }
      
      this.$swal.fire({
        type: 'warning',
        title: '確認刪除？',
        text: `即將刪除未使用序號共 ${unusedCount} 筆`,
        showCancelButton: true,
        confirmButtonText: '確定刪除',
        cancelButtonText: '取消',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        reverseButtons: true
      }).then(async (result) => {
        if (result.value) {
          await this.executeBatchDelete();
        }
      });
    },
    async executeBatchDelete() {
      try {
        this.isLoading = true;

        // 只刪除未使用的序號
        const idsToDelete = this.selectedItems
          .filter(item => !item.redeem_at)
          .map(item => item.id);

        if (idsToDelete.length === 0) {
          return;
        }

        await partnerMarketingPlanSerial.deleteCodes(this.planId, {
          ids: idsToDelete
        });

        this.$swal.fire({
          type: 'success',
          text: `成功刪除 ${idsToDelete.length} 筆序號`
        });

        // 重新載入列表
        this.cancelDeleteMode();
        await this.fetchSerialStats();
        await this.fetchList(this.pagination.page);

      } catch (error) {
        console.error('Failed to delete codes:', error);
        this.$swal.fire({
          type: 'error',
          title: '刪除失敗',
          text: error.response?.data?.message || '發生錯誤，請稍後再試'
        });
      } finally {
        this.isLoading = false;
      }
    },
    canDelete(item) {
      // 只有未指派、未領取、未使用的序號才能刪除
      return !item.belong_at && !item.apply_at && !item.redeem_at;
    },
    async toggleCodeStatus(item) {
      this.$swal.fire({
        type: 'question',
        title: '確認變更狀態',
        text: `確定要${item.is_enabled ? '停用' : '啟用'}此序號嗎？`,
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then(async (result) => {
        if (result.value) {
          await this.executeToggleStatus(item);
        }
      });
    },
    async executeToggleStatus(item) {
      try {
        this.isLoading = true;

        const response = await partnerMarketingPlanSerial.toggleStatus(this.planId, item.id);

        // 更新列表中的項目狀態
        const index = this.serials.findIndex(serial => serial.id === item.id);
        if (index !== -1) {
          this.serials[index].is_enabled = response.data.data.is_enabled;
        }

        this.$swal.fire({
          type: 'success',
          title: '狀態更新成功',
          text: `序號已${response.data.data.is_enabled ? '啟用' : '停用'}`,
          timer: 1500,
          showConfirmButton: false
        });

      } catch (error) {
        console.error('Failed to toggle status:', error);
        this.$swal.fire({
          type: 'error',
          title: '狀態更新失敗',
          text: error.response?.data?.message || '發生錯誤，請稍後再試'
        });
      } finally {
        this.isLoading = false;
      }
    },
    async deleteCode(item) {
      if (!this.canDelete(item)) {
        this.$swal.fire({
          type: 'warning',
          title: '無法刪除',
          text: '只有未指派、未領取、未使用的序號才能刪除'
        });
        return;
      }

      this.$swal.fire({
        type: 'warning',
        title: '確認刪除',
        text: '確定要刪除此序號嗎？刪除後無法復原',
        showCancelButton: true,
        confirmButtonText: '確定刪除',
        cancelButtonText: '取消',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        reverseButtons: true
      }).then(async (result) => {
        if (result.value) {
          await this.executeSingleDelete(item);
        }
      });
    },
    async executeSingleDelete(item) {
      try {
        this.isLoading = true;

        await partnerMarketingPlanSerial.deleteCodes(this.planId, {
          ids: [item.id]
        });

        this.$swal.fire({
          type: 'success',
          text: '序號刪除成功'
        });

        // 重新載入列表和統計
        await this.fetchSerialStats();
        await this.fetchList(this.pagination.page);

      } catch (error) {
        console.error('Failed to delete code:', error);
        this.$swal.fire({
          type: 'error',
          title: '刪除失敗',
          text: error.response?.data?.message || '發生錯誤，請稍後再試'
        });
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>